<template>
  <div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.applicantFirstName"
                    label="Applicant First Name"
                    placeholder="Applicant First Name"
                    :validation="val.form.applicantFirstName" />
      </div>
      <div class="col">
        <base-input v-model="form.applicantLastName"
                    label="Applicant Last Name"
                    placeholder="Applicant Last Name"
                    :validation="val.form.applicantLastName" />
      </div>
      <div class="col">
        <base-input v-model="form.applicantPhone"
                    label="Applicant Phone"
                    type="tel"
                    mask="(###)-###-####"
                    placeholder="(xxx)-xxx-xxxx"
                    :validation="val.form.applicantPhone" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-input v-model="form.applicantEmail"
                    label="Applicant Email"
                    placeholder="Applicant Email"
                    type="email"
                    :validation="val.form.applicantEmail" />
      </div>
      <div class="col">
        <base-input v-model="form.confirmEmail"
                    label="Confirm Email"
                    placeholder="Confirm Email"
                    type="email"
                    :validation="val.form.confirmEmail" />
      </div>
    </div>

    <div class="row w-100">
      <div class="col">
        <label> Applicant Address </label>
        <v-address v-model="form.applicantAddress"
                   labelPrefix="Applicant Address"
                   :show-unincorporated="false"
                   :validation="val.form.applicantAddress" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-select v-model="form.typeOfRequest"
                     :options="formFieldData.typeOfRequestOptions"
                     :validation="val.form.typeOfRequest"
                     label="Type of Burn Request">
        </base-select>
      </div>
      <div class="col" v-if="form.typeOfRequest == 'Other'">
        <base-input v-model="form.typeOfRequestOtherDesc"
                    label="Other (Specify)"
                    placeholder="Description"
                    :validation="val.form.typeOfRequestOtherDesc" />
      </div>
    </div>

    <div class="row w-100">
      <div class="col">
        <p class="font-14">
          Attach to this application (1) A sketch of the immediate vicinity of the site, and (2) a printed map of the general area with the site and nearby features marked.
          Together these maps must describe the site and provide the distance to nearby features, including adjacent structures, residences, populated areas, roadways, airports, lakes and waterways, hospitals, nursing homes and schools.
        </p>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-6">
        <base-file-uploader v-model="form.files.vicinitySketch"
                            label="Sketch of Immediate Vicinity"
                            :file="form.existingFileDetails.vicinitySketch" />
      </div>
      <div class="col-6">
        <base-file-uploader v-model="form.files.printedMap"
                            label="Printed Map of General Area"
                            :file="form.existingFileDetails.printedMap" />
      </div>
    </div>

    <div class="w-100" v-if="form.typeOfRequest == 'Firefighting Instruction / Research'">
      <div class="row w-100">
        <div class="col-6">
          <yes-no v-model="form.donatedBuilding"
                  label="Are you burning a donated Building?"
                  message="Are you burning a donated Building?" />
        </div>
        <div class="w-100" v-if="form.donatedBuilding">
          <div class="row w-100">
            <div class="col">
              <p class="font-14" style="font-weight: bold;">For Fire Training Only: <span style="text-decoration: underline;">Asbestos assessment required</span>. Building must not be burned down to the ground, Cook County Environmental Control issued demolition permit required to demolish building.</p>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-6">
              <base-file-uploader v-model="form.files.asbestosAssessmentFile"
                                  label="Asbestos Assessment"
                                  :file="form.existingFileDetails.asbestosAssessmentFile"
                                  :validation="val.form.files.asbestosAssessmentFile" />
            </div>
            <div class="col-6">
              <base-file-uploader v-model="form.files.demolitonPermit"
                                  label="Demolition Permit"
                                  :file="form.existingFileDetails.demolitonPermit" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-navigation link="burninfo">Burn Information</bottom-navigation>
  </div>
</template>

<script>
import VAddress from '~/components/VAddress';
import BaseInput from '~/components/BaseInput';
import BaseSelect from '~/components/BaseSelect';
import BaseFileUploader from '~/components/BaseFileUploader';
import BottomNavigation from '~/components/BottomNavigation';
import YesNo from '~/components/YesNo';
import { OpenBurnFormData } from '../../../js/FormObjects';

export default {
  name: 'ApplicantInfo',
  props: ['form', 'val'],
  components: {
    VAddress, BaseInput, BaseSelect, BaseFileUploader, YesNo, BottomNavigation,
  },
  data() {
    return {
      registerUrl: '',
      loginUrl: '',
      formFieldData: new OpenBurnFormData(),
      // form: this.$parent.form
    };
  },
  mounted() {

  },
  methods: {

  },
};

</script>
